export default {
  EAT_SYMBOLS: 'symbols',
  EAT_BIG_WIN: 'bigWin_spine',
  SYMBOL_FRAME: 'symbolFrame',
  EAT_JACKPOT: 'jackpot'
}
